<template>
  <div id="form-crud-shape">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    <div class="card border-0 shadow p-3">
      <form @submit.prevent="initSubmit">

        <div class="form-group">
          <label for="name">{{ $t('common.name') }} *</label>
          <input class="form-control" id="name" v-model="shape.name" type="text">
          <div v-if="errorsForm.number">
            <p class="form-error text-danger" v-for="(error, index) in errorsForm.number.errors" :key="index">{{ error }}</p>
          </div>
        </div>

        <input type="submit" class="btn mt-4 mb-2 btn-success" :value="valueButtonSubmit" />
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    shape: Object,
    id: Number,
    actionForm: String
  },
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      },
      errorsForm: [],
    }
  },
  created: function() {
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
    /*----------------- SUBMIT ------------------*/
    initSubmit()
    {
      if(this.actionForm === 'edit')
      {
        this.edit()
      }
      else {
        this.create()
      }
    },

    create() {

      this.showLoader()

      this.$store.dispatch('createShape', this.shape)
          .then(() => {
            this.hideLoader()
            this.redirectAndRefresh()
          })
          .catch((errors) => {
            this.hideLoader()
            this.errorsForm = errors
          })
    },

    edit() {
      this.showLoader()

      this.$store.dispatch('updateShape', { id: this.shape.id, shape: this.shape })
          .then(() => {
            this.hideLoader()
            this.redirectAndRefresh()
          })
          .catch((errors) => {
            this.hideLoader()
            this.errorsForm = errors
          })
    },

    redirectAndRefresh()
    {
      // Redirect
      this.$router.push({ name: 'shape-index' })

      // Refresh errors form
      this.errorsForm = []
    }
  },
  computed: {
    /**
     * Display value for button submit
     * @returns {string}
     */
    valueButtonSubmit() {
      let value = ''
      if(this.actionForm === 'edit')
      {
        value = this.$t('pages.shape.editShape')
      }
      else {
        value = this.$t('pages.shape.createShape')
      }

      return value
    },
    ...mapState(['ShapeModule'])
  },
  components: {
    Loading: () => import('vue-loading-overlay')
  }
}
</script>
